(function () {
  'use strict';

  /* ---- Auto-activate second tab on load ---- */
  window.addEventListener('DOMContentLoaded', function () {
    var btns     = document.querySelectorAll('.custom-tabs .tab-btn');
    var contents = document.querySelectorAll('.tab-content');
    if (btns.length >= 2) {
      btns.forEach(function (b) { b.classList.remove('active'); });
      contents.forEach(function (c) { c.classList.remove('active'); });
      btns[1].classList.add('active');
      var id = btns[1].getAttribute('data-tab') + '-content';
      var el = document.getElementById(id);
      if (el) el.classList.add('active');
      setTimeout(updateReviews, 100);
    }
  });

  /* ---- Tabs ---- */
  var tabBtns     = document.querySelectorAll('.custom-tabs .tab-btn');
  var tabContents = document.querySelectorAll('.tab-content');

  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      tabBtns.forEach(function (b) { b.classList.remove('active'); });
      tabContents.forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
      var content = document.getElementById(btn.getAttribute('data-tab') + '-content');
      if (content) content.classList.add('active');
      setTimeout(updateReviews, 100);
    });
  });

  /* ---- Add to Cart ---- */
  document.addEventListener('click', function (e) {
    if (!e.target.classList.contains('skin-rhythms-add-to-cart')) return;
    e.preventDefault(); e.stopPropagation();
    var btn       = e.target;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled) return;

    var orig = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (res) {
      if (!res.ok) throw new Error();
      btn.textContent = '✓ Added';
      btn.style.backgroundColor = '#4CAF50';
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      fetch(window.location.origin + '/?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
        var drawer = document.querySelector('#CartDrawer');
        if (parsed && drawer) drawer.innerHTML = parsed.innerHTML;
      });

      setTimeout(function () {
        var cd = document.querySelector('cart-drawer');
        if (cd) {
          cd.classList.remove('is-empty'); cd.classList.add('active', 'animate');
          var ov    = cd.querySelector('#CartDrawer-Overlay');
          var inner = cd.querySelector('.drawer__inner');
          if (ov)    ov.style.display = 'block';
          if (inner) inner.setAttribute('aria-hidden', 'false');
          document.body.classList.add('overflow-hidden');
        }
      }, 200);

      setTimeout(function () { btn.textContent = orig; btn.disabled = false; btn.style.backgroundColor = ''; }, 3000);
    }).catch(function () {
      btn.textContent = 'Error'; btn.style.backgroundColor = '#f44336';
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; btn.style.backgroundColor = ''; }, 3000);
    });
  });

  /* ---- Judge.me reviews ---- */
  function updateReviews() {
    document.querySelectorAll('.reviews-overlay[data-product-id]').forEach(function (el) {
      var id    = el.getAttribute('data-product-id');
      var badge = document.querySelector('.jdgm-widget[data-id="' + id + '"] .jdgm-prev-badge') ||
                  document.querySelector('.jdgm-prev-badge[data-id="' + id + '"]');
      if (!badge) return;
      var avg = badge.getAttribute('data-average-rating');
      var cnt = badge.getAttribute('data-number-of-reviews');
      if (avg && cnt && cnt !== '0') {
        el.querySelector('.rating-number').textContent = parseFloat(avg).toFixed(1);
        el.querySelector('.review-count').textContent  = cnt;
        el.style.display = 'flex';
      }
    });
  }

  var tries = 0;
  var timer = setInterval(function () {
    if (document.querySelector('.jdgm-prev-badge') || ++tries >= 50) { updateReviews(); clearInterval(timer); }
  }, 200);

  new MutationObserver(function (mutations) {
    var changed = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (n) {
        return n.nodeType === 1 && ((n.classList && n.classList.contains('jdgm-prev-badge')) || (n.querySelector && n.querySelector('.jdgm-prev-badge')));
      });
    });
    if (changed) setTimeout(updateReviews, 100);
  }).observe(document.body, { childList: true, subtree: true });

  setTimeout(updateReviews, 300);
})();